import React, { useState, useCallback, useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Form from './form';
import Detail from './detail';
import FormModal from '../../../FormModal';
import ModalCheckin from './ModalCheckin';
import useStyles from './styles';

const SchedulingBarcode = ({
  open,
  onClose,
  onSearch,
  onConfirm,
  scheduling,
  enableCalled,
  setAdditionalInfoCalled
}) => {

  const classes = useStyles();
  const [schedulingData, setSchedulingData] = useState(null);
  const [clearInputBarcode, setClearInputBarcode] = useState(false);

  const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
  const [openSnackbarError, setOpenSnackbarError] = useState(false);
  const [isOpenModalCheckin, setOpenModalCheckin] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setSchedulingData(scheduling);
  }, [scheduling]);

  const handleConfirm = useCallback(async () => {
   if (scheduling?.branch_config?.enable_called) {
      setOpenModalCheckin(true);
   } else {
      await onConfirm(schedulingData.id);
      setOpenSnackbarSuccess(true);
      setSchedulingData(null);
      setClearInputBarcode(true);
   }
  }, [schedulingData, setSchedulingData, onConfirm, setOpenSnackbarSuccess, scheduling]);

  const handleSearch = useCallback(async (barcode) => {
    setClearInputBarcode(false);
    try {
      await onSearch(barcode);
    } catch (e) {
      setOpenSnackbarError(true);
      setClearInputBarcode(true);
      setErrorMessage(e.info.title);
      throw e;
    }
  }, [onSearch, setClearInputBarcode, setOpenSnackbarError]);

  const handleCloseSnackbarSuccess = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbarSuccess(false);
  };

  const handleCloseSnackbarError = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbarError(false);
  };

  const handleCancel = useCallback(() => {
    setSchedulingData(null);
    setOpenSnackbarError(false);
    setOpenSnackbarSuccess(false);
    onClose();
  }, [onClose, setSchedulingData, setOpenSnackbarError, setOpenSnackbarSuccess]);

  const handleConfirmDriverInfo = async (payload) => {
      try{
        const response = await setAdditionalInfoCalled({ ...payload, id: schedulingData.id });
        if(response?.success === false) {
          setOpenModalCheckin(true);
          setOpenSnackbarError();
          setErrorMessage(response.message);
          return response;
        }
        setOpenSnackbarSuccess(true);
        setSchedulingData(null);
        setClearInputBarcode(true);
        setOpenModalCheckin(false);
        return response;
      } catch (e) {
        setOpenModalCheckin(true);
        throw e;
      }

 }

  return (
    <FormModal
      open={open}
      handleClose={handleCancel}
      showIconClose={false}
      title="Leitura de Código de Barras"
    >
      <Snackbar className={classes.snackbar} open={openSnackbarSuccess} autoHideDuration={6000} onClose={handleCloseSnackbarSuccess}>
        <Alert severity="success">
          Checkin realizado com sucesso!
        </Alert>
      </Snackbar>
      <Snackbar className={classes.snackbar} open={openSnackbarError} autoHideDuration={6000} onClose={handleCloseSnackbarError}>
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
      <Form
        clearValue={clearInputBarcode}
        onClear={() => setSchedulingData(null)}
        onSubmit={handleSearch}
      />
      <Detail
        scheduling={schedulingData}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <ModalCheckin
        open={isOpenModalCheckin}
        hasQueueOrder={schedulingData?.branch_config?.enable_called_queue_order}
        onClose={() => setOpenModalCheckin(false)}
        onConfirm={handleConfirmDriverInfo}
      />
    </FormModal>
  );
};

export default SchedulingBarcode;
